export default function MoleForgeSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        The octet rule, made tangible
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most chemistry textbooks introduce covalent bonding with a picture
        of electron dots and a paragraph about wanting eight electrons in
        the outer shell. The picture is correct. The paragraph is correct.
        Together they are surprisingly hard to remember. MoleForge inverts
        the teaching: instead of memorizing the rule, you use it. Hydrogen
        wants one bond — try giving it two and the forge rejects. Carbon
        wants four bonds — try giving it three and the forge rejects.
        Every successful molecule in MoleForge is a molecule where every
        atom got exactly the number of bonds it wanted. After half an hour
        of building, "carbon has four bonds" stops being a fact to recall
        and starts being a shape your hand remembers. That's what Gilbert
        Lewis discovered in 1916, and that's why he gets a badge here.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why benzene is its own subfield
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Most molecules in MoleForge are chains: a string of atoms with a
        clear start and end. Water is a 3-atom chain. Methane is a center
        with four branches. Ethanol is a chain with a hook. Benzene is
        different. Six carbons connect to themselves in a closed ring,
        with alternating single and double bonds, and the result has
        properties no chain molecule has. The chemistry built around ring
        molecules — aromatic chemistry — is its own subfield, with rules
        and reactions chains can't match. August Kekulé proposed the ring
        structure of benzene in 1865, reportedly after dreaming of a
        snake biting its own tail. Whether or not the dream story is
        embellished (chemists have argued for over a century), the ring
        was the unlock that made the rest of organic chemistry tractable.
        In MoleForge, benzene is the level-5 mastery — the topology you
        won't have built before, and that earns Kekulé's Benzene.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        From H₂ to C₆H₆ — a curriculum arc
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        MoleForge progresses through five levels, mirroring the way
        chemistry is usually introduced. Level 1 starts with diatomics
        and the water family — the simplest molecules with one or two
        atom types. Level 2 adds carbon and introduces the multiple-bond
        idea via ethene (C=C) and ethyne (C≡C). Level 3 brings in
        nitrogen and a glimpse of biology: ammonia, hydrogen cyanide,
        urea. Level 4 brings in sodium and chlorine — the salt-makers —
        and shows that bonds aren't always purely covalent. Level 5 is
        benzene alone. By the time you build that ring, you've seen
        every bond order, every valence in the palette, and every
        topology shape that organic chemistry cares about. MoleForge is
        free, no signup, your discoveries stay on your device.
      </p>
    </>
  );
}
